import Vue from 'vue'
import Vuex from 'vuex'
import authentication from './modules/authentication'
import { Howl } from 'howler';

Vue.use(Vuex)

export default new Vuex.Store( {
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    authentication
  },
  state: {
    socket: {
      connected: false
    },
    error: {
      enable: false,
      message: ''
    },
    homePage: {
      today: 0,
      yesterday: 0,
      thisweek: 0,
      lastweek: 0
    },
    user_online: 0
  },
  actions: {
    playSound( ) {
      const sound = new Howl({
        src: ['/sound/s3.webm', '/sound/s3.mp3', '/sound/s3.wav'],
        volume: 1.0,
      });

      sound.play();
    },
    SOCKET_new_statistic( { dispatch } ) {
      dispatch( 'playSound' )
    }
  },
  mutations: {
    error( state, data ) {
      state.error.enable = data.enable
      state.error.message = data.message
    },
    SOCKET_connect( state ) {
      state.socket.connected = true
    },
    SOCKET_reconnect( state ) {
      state.socket.connected = true
    },
    SOCKET_disconnect( state ) {
      state.socket.connected = false
      state.user_online = 0
    },
    SOCKET_user_online( state, count ) {
      state.user_online = count
    }
  }
} )
